import { HGATE_INCLUDED, USE_THETRARIS_LOGO } from '../../../../shared/env';

import { FaqPage as FaqDefault } from './Faq';
import { FaqPage as FaqEN } from './FaqEN';
import { FaqPage as FaqInni } from './FaqInni';

export const Faq = HGATE_INCLUDED
  ? FaqDefault
  : USE_THETRARIS_LOGO
  ? FaqInni
  : FaqEN;
